import './App.css';
import Home from './components/Home.js'
import AuthPage from './components/AuthPage.js'
import CatalogJewellery from './components/CatalogJewellery.js';
import JewelleryDetails from './components/JewelleryDetails.js';
import VerifyRegistration from './components/VerifyRegistration.js';
import ForgotPassword from './components/ForgotPassword.js';
import NewPassword from './components/NewPassword.js';
import UploadPhoto from './components/UploadPhoto.js';
import UpdateJewelleryDetails from './components/UpdateJewelleryDetails.js';
import Passport from './components/Passport.js';
import BrandAuth from './components/BrandAuth.js';
import BrandDashboard from './components/BrandDashboard.js';
import CreateProductWizard from './components/CreateProductWizard.js';
import ManageCataloguePage from './components/ManageCataloguePage.js';
import UserAuth from './components/UserAuth.js';
import UserCollection from './components/UserCollection.js';
import ClaimTransfer from './components/ClaimTransfer.js';
import SiteFooter from './components/SiteFooter.js';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';


function App() {

  return (
    <Router>
    <Routes>
      <Route path="/" element={<Home/>} />
      <Route path="/login" element={<AuthPage/>}/>
      <Route path="/verify-registration" element={<VerifyRegistration/>}/>
      <Route path="/forgot-password" element={<ForgotPassword/>}/>
      <Route path="/new-password" element={<NewPassword/>}/>
      <Route path="/jewellery" element={<CatalogJewellery/>}/>
      <Route path="/jewellery/details" element={<JewelleryDetails/>}/>
      <Route path="/jewellery/details/update" element={<UpdateJewelleryDetails/>}/>
      <Route path="/jewellery/:qrCodeId" element={<Passport/>}/>
      <Route path="/upload-photo" element={<UploadPhoto/>}/>
      <Route path="/brand" element={<BrandAuth/>}/>
      <Route path="/brand/dashboard" element={<BrandDashboard/>}/>
      <Route path="/brand/products/new" element={<CreateProductWizard/>}/>
      <Route path="/brand/catalogue" element={<ManageCataloguePage/>}/>
      <Route path="/user" element={<UserAuth/>}/>
      <Route path="/user/collection" element={<UserCollection/>}/>
      <Route path="/transfer/claim/:tokenId" element={<ClaimTransfer/>}/>
    </Routes>
    <SiteFooter/>
    </Router>
  );
}

export default App;
